import { withProps, withHandlers, compose, withState, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { formatPhoneNumbers } from '../AppointmensLocationItem/helpers'
import withRedirect from 'components/common/hoc/withRedirect'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import withConfigureHandleShopTires from 'components/common/hoc/withConfigureHandleShopTires'
import { STORE_DETAILS_PAGE } from 'constant'
import LocationItem from './LocationItem'
import { activateMarchexScript } from 'helpers/custom-events'
import { getCurrentStoreId } from 'selectors/getCurrentStore'
import { selectMyStore } from 'actions/storeLocator'
import { getLocationPathname } from 'selectors/getPageLocation'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'

const mapStateToProps = ({ app: { isFetching = false } = {}, ...state }, { storeId }) => ({
  isSaved: getCurrentStoreId(state) === storeId,
  isFetching,
  pathname: getLocationPathname(state)
})

const withFormattedLocationDetails = withProps(({
  address: {
    zipcode,
    city,
    address1,
    state
  },
  phoneNumbers
}) => ({
  addressObject: {
    zipcode,
    city,
    address1,
    state
  },
  street: address1,
  address: `${city}, ${state} ${zipcode}`,
  phoneNumbers: formatPhoneNumbers(phoneNumbers)
}))

const withStoreChanged = withState('storeChanged', 'updateStoreChanged', false)

const withSelectStoreProps = withProps(({ selectMyStore, handleSelectStore }) => ({
  hasCustomHandler: Boolean(handleSelectStore),
  selectStore: (handleSelectStore || selectMyStore)
}))

const withSelectStoreHandler = withHandlers({
  selectStoreHandler: ({
    selectStore,
    updateStoreChanged,
    storeNumber,
    addressObject,
    storeDetailsUrl,
    redirectTo,
    pathname
  }) => () =>
    selectStore({ storeNumber, addressObject })
      .then(() => pathname.startsWith(STORE_DETAILS_PAGE) && redirectTo(storeDetailsUrl))
      .then(updateStoreChanged(true))
      .then(() => activateMarchexScript())
})

const withLifecycle = lifecycle({
  componentDidUpdate({ isFetching: prevIsFetching }) {
    const {
      isFetching,
      storeChanged,
      preventExpandingQuickAppointmentMenu,
      storeDetailsUrl,
      redirectTo
    } = this.props

    prevIsFetching &&
    !isFetching &&
    storeChanged &&
    !preventExpandingQuickAppointmentMenu &&
    redirectTo(storeDetailsUrl)
  }
})

export default compose(
  withFormattedLocationDetails,
  connect(mapStateToProps, { selectMyStore }),
  withRedirect,
  withStoreChanged,
  withSelectStoreProps,
  withSelectStoreHandler,
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withLifecycle,
  withHandlePhoneLinkClick,
  withConfigureHandleShopTires
)(LocationItem)
